<template>
  <section class="commic_page">
    <div class="commic_wrapper">
      <div class="commic_list">
        <template v-for="(item, index) of commicList">
          <div class="commit_item" v-if="item" :key="index">
            <div class="item_top_wrapper">
              <img
                :src="item.banner"
                alt=""
                class="item_top"
                @click="toPage('/comic_section', { comicId: item.id ,fromId:1})"
              />
              <div class="top_bg"></div>
            </div>
            <div class="item_bottom">
              <div class="title">{{ item.title }}</div>
              <div class="writer">{{ item.author }}</div>
            </div>
          </div>
        </template>
      </div>
      <div class="list_btn" @click="toPage('/comic')">
        <img
          src="../../assets/images/home/commic/arrow.png"
          alt=""
          class="arr"
        />
        <div class="text">LIST</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      commicList: [],
    };
  },
  methods: {
    toPage(path, query = '') {
      this.$router.push({path, query});
    },
  },
  computed: {},
  mounted() {
    this.axios
      .get(
        `${process.env.VUE_APP_COMMIC_HOST}/api/comic?page=1&size=6&sort=id%2Cdesc`
      )
      .then((v) => {
        console.log('v', v);
        this.commicList = v.data;
      });
  },
};
</script>

<style lang="scss" scoped>
.commic_page {
  background: url('../../assets/images/home/commic/commic_bg.png') no-repeat;
  background-position: center;
  background-size: cover;
  .commic_wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    width: pxTorem(1186px);
    box-sizing: border-box;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .commic_list {
      display: flex;
      flex-wrap: wrap;
       min-height: pxTorem(670px);
      .commit_item {
        margin-right: pxTorem(38px);
        margin-bottom: pxTorem(30px);
        &:nth-child(3n) {
          margin-right: 0;
        }
        .item_top_wrapper {
          position: relative;
          width: pxTorem(370px);
          height: pxTorem(240px);
          .item_top {
            cursor: pointer;
            width: pxTorem(370px);
            height: pxTorem(240px);
            position: absolute;
            z-index: 1;
            top: 0;
            right: 0;
          }
          .top_bg {
            width: pxTorem(370px);
            height: pxTorem(240px);
            background-color: #fff;
            position: absolute;
            left: 0;
            right: 0;
            transform: rotate(-2deg);
          }
        }
        .item_bottom {
          box-sizing: border-box;
          padding: pxTorem(6px) 0 pxTorem(6px) pxTorem(9px);
          margin-top: pxTorem(16px);
          background: url('../../assets/images/home/commic/rect_bottom.png')
            no-repeat;
          background-position: 0 0;
          background-size: cover;
          width: pxTorem(370px);
          height: pxTorem(50px);
          .title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: pxTorem(16px);
            font-family: NotoSansCJKkr_B;
            font-weight: bold;
            color: #000000;
            line-height: pxTorem(20px);
          }
          .writer {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: pxTorem(16px);
            font-family: NotoSansCJKkr_R;
            color: #000000;
            line-height: pxTorem(20px);
          }
        }
      }
    }
    .list_btn {
      align-self: flex-end;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: pxTorem(193px);
      height: pxTorem(50px);
      border: pxTorem(1px) solid #ffffff;
      &:hover .arr {
        transform: translateX(pxTorem(6px));
      }
      .arr {
        transition: all 0.3s;
        width: pxTorem(20px);
        height: pxTorem(13px);
      }
      .text {
        margin-left: pxTorem(20px);
        font-size: pxTorem(18px);
        font-family: Bender;
        font-weight: 400;
        color: #ffffff;
        line-height: pxTorem(18px);
      }
    }
  }
}
</style>
